import React from 'react';
import { isReskin } from '../config/siteVariant';
import DashboardPageLegacy from './DashboardPageLegacy';
import DashboardPageReskin from './DashboardPageReskin';

/**
 * DashboardPage variant selector. Renders the re-skin dashboard only on a
 * build compiled with REACT_APP_SITE_VARIANT=reskin; otherwise the legacy
 * production dashboard. See src/config/siteVariant.js.
 */
const DashboardPage = (props) =>
  isReskin ? <DashboardPageReskin {...props} /> : <DashboardPageLegacy {...props} />;

export default DashboardPage;
